/* eslint-disable jsx-a11y/img-redundant-alt */
import { DataGrid } from '@mui/x-data-grid';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './CropList.css';  // Use a new CSS file or reuse the same as AdminList
import BASE_URL from '../../../config/apiConfig';

function CropList() {
    const [data, setData] = useState([]);

    // Fetch crop data from API on component mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                const cropResponse = await axios.get(`${BASE_URL}/api/admin/crops`);
                const transformedData = cropResponse.data.map(crop => ({
                    id: crop.crop_id,  // Use crop_id as id
                    name: crop.crop_name,
                    price: crop.per_hectare_price,
                }));
                setData(transformedData);
            } catch (error) {
                console.error('Error fetching crops:', error);
            }
        };

        fetchData();
    }, []);

    const handleDlt = (id) => {
        setData(data.filter((item) => item.id !== id));
    };

    const columns = [
        {
            field: 'id',
            headerName: 'Crop ID',
            width: 200,
        },
        {
            field: 'name',
            headerName: 'Crop Name',
            width: 180,
        },
        {
            field: 'price',
            headerName: 'Price per Hectare',
            width: 280,
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 150,
            renderCell: (params) => (
                <div className="actionn">
                    <button
                        type="button"
                        className="delete_btn"
                        onClick={() => handleDlt(params.row.id)}
                    >
                        Delete
                    </button>
                </div>
            ),
        },
    ];

    return (
        <div className="data_table">
            <DataGrid
                className="data_grid"
                rows={data}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                checkboxSelection
            />
        </div>
    );
}

export default CropList;
